import React from "react";
import { Button } from "@mui/material";
import {
  endImpersonation,
  getImpersonationLabel,
  isImpersonating,
} from "../../utils/impersonation";

const ImpersonationBanner = () => {
  if (!isImpersonating()) return null;

  const label = getImpersonationLabel();

  return (
    <div className="fixed top-0 left-0 right-0 z-[10000] bg-[#1F2937] text-white px-4 py-2 flex items-center justify-between gap-3 text-[13px]">
      <div className="font-medium truncate">
        Support view: <span className="font-semibold">{label}</span>
      </div>
      <Button
        onClick={() => endImpersonation()}
        size="small"
        sx={{
          textTransform: "none",
          bgcolor: "white",
          color: "#111827",
          fontWeight: 600,
          borderRadius: "6px",
          px: 1.5,
          py: 0.25,
          minWidth: 0,
          "&:hover": { bgcolor: "#F3F4F6" },
        }}
      >
        End session
      </Button>
    </div>
  );
};

export default ImpersonationBanner;
